const sliderTimeline = () => {
    const sections = document.querySelectorAll('.slider-timeline');
    if (!sections.length) return;

    sections.forEach(section => {
        const slider = section.querySelector('.slider-timeline__swiper');
        if (!slider) return;

        new Swiper(slider, {
            slidesPerView: 3,
            spaceBetween: 0,
            loop: true,
            centeredSlides: true,
            allowTouchMove: false,
            navigation: {
                prevEl: section.querySelector('.slider-timeline__btn-prev'),
                nextEl: section.querySelector('.slider-timeline__btn-next'),
            },
        });
    });
};

export default sliderTimeline;
